import { Component, OnInit, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  stagger,
  keyframes,
  query,
  animate,
  transition
} from '@angular/animations'
import { NavService } from 'src/app/services/nav.service';

// Require EmailJs service
// http://www.emailjs.com
import * as emailjs from 'emailjs-com';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-project-contact',
  templateUrl: './project-contact.component.html',
  styleUrls: ['./project-contact.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1.2s', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('0.4s', style({ opacity: 0 }))
      ])
    ]),
  ]
})
export class ProjectContactComponent implements OnInit {
  public formFields: object = {
    firstName: null,
    lastName: null,
    email: null, 
    subject: null, 
    message: null
  }

  public formSubmitted: boolean = false
  public formMessage: string = `<h4>Thanks for your message, <br>we'll get back to you asap.</h4>`


  @Input() headline: string
  @Input() _editable: any
  constructor(
    private nav: NavService
  ) { }

  ngOnInit() {
      // Init emailJS with user code
      emailjs.init(environment.emailJs.userId);
  }

  focusField(e) {
    const target = e.target
    const field = target.parentElement
    
    field.classList.add('active')
  }

  unFocusField(e) {
    const target = e.target
    const field = target.parentElement
    
    field.classList.remove('active')
  }

  processForm() {
    const formData = this.formFields
    const templateParams = {
      firstName: formData['firstName'],
      lastName: formData['lastName'],
      email: formData['email'],
      subject: formData['subject'],
      message: formData['message']
    }

    emailjs.send('default_service', 'contact_form', templateParams)
    .then((response) => {
      console.log(`Success, ${response.status}, ${response.text}`);

      setTimeout(() => {
        this.formSubmitted = true
      }, 800)
  
      setTimeout(() => {
        this.clearForm()
        this.formSubmitted = false
      }, 5000)
    }, (err) => {
      console.log(`Failed: ${err}`);
    })

    console.log(formData, templateParams)
  }

  clearForm() {
    for (let key in this.formFields) {
      this.formFields[key] = null
    }
  }

  public onIntersection({ target, visible }, id): void {
    if(visible) {
      this.nav.changeActiveNavItem(id)
    }
  }
}
